import PropTypes from "prop-types";
import CategoriesMobile from "./mobile/Mobile";
import CategoriesDesktop from "./desktop/Desktop";

function Categories({ type, currentItem, categoriesFaq, categoriesList }) {
    if (type === "mobile") {
        return (
            <CategoriesMobile
                currentItem={currentItem}
                categoriesList={categoriesList}
            />
        );
    }

    return <CategoriesDesktop categoriesFaq={categoriesFaq} />;
}

Categories.defaultProps = {
    type: "desktop",
    currentItem: undefined,
    categoriesFaq: undefined,
    categoriesList: undefined
};

Categories.propTypes = {
    type: PropTypes.string,
    currentItem: PropTypes.string,
    categoriesFaq: PropTypes.arrayOf(PropTypes.object),
    categoriesList: PropTypes.arrayOf(PropTypes.object)
};

export default Categories;
